import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const role = params.get("role") || "creator";

    if (!sessionId) {
      navigate("/auth?mode=login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, role });
        window.history.replaceState({}, "", "/");
        await refresh();
        navigate(data.user?.role === "brand" ? "/brand" : "/creator", { replace: true });
      } catch {
        navigate("/auth?mode=login&error=google", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen grain flex items-center justify-center">
      <div className="glass rounded-2xl p-8 text-center max-w-sm" data-testid="auth-callback">
        <Loader2 className="h-6 w-6 animate-spin mx-auto mb-3 text-nexus-purple" />
        <div className="font-display font-bold text-lg">Signing you in…</div>
        <div className="text-xs text-zinc-400 mt-1">One moment while we secure your session.</div>
      </div>
    </div>
  );
}
